export default __webpack_public_path__ + "static/media/VisbyCF-Bold.d1de16d5.otf";